module.exports = __webpack_public_path__ + "assets/img/newsIcon2.ebc90261.png";